import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import colors, { LIGHTGREY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const RadioContainer = styled.label`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 110px;
  border: 1px solid ${LIGHTGREY};
  border-radius: 12px;
  padding: 30px 30px 30px 80px;
  cursor: pointer;
  transition: 0.5s;

  ${breakpoints.down('xs')} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 18px 40px 24px 56px;
    min-height: auto;
  }

  &:hover {
    border-color: ${p => p.theme.palette.primary.main || colors.primary};
  }

  &.radio-card {
    &--checked {
      border-color: ${p => p.theme.palette.primary.main || colors.primary};
      background-color: ${p => rgba(p.theme.palette.primary.main || colors.primary, 0.05)};

      .radio-card__title {
        color: ${p => p.theme.palette.primary.main || colors.primary};
      }
    }

    .radio-card {
      &__title {
        width: 33.33%;

        ${breakpoints.down('xs')} {
          width: 100%;
          margin-bottom: 10px;
        }
      }

      &__icon {
        position: absolute;
        left: 30px;

        ${breakpoints.down('xs')} {
          left: 18px;
        }
      }

      &__btn {
        flex-shrink: 0;

        ${breakpoints.down('xs')} {
          margin-top: 16px;
          width: 100%;
        }
      }

      &__dummy-btn {
        width: 129px;
      }
    }

    &:not(:last-of-type) {
      margin-bottom: 16px;
    }

    input[type='radio'] {
      display: none;
    }
  }

  .price {
    &__discount {
      display: block;
    }
  }
`;

export default RadioContainer;
